export default __webpack_public_path__ + "static/media/494.d7d97398.gif";